import React from 'react';

import { Grid } from '@material-ui/core';

import { useStyles } from './styles';

import { usePartner } from '../../context/PartnerContext';

/**
 *
 * @Header Componente para exibicao de um Header fixo da aplicação
 * @CriadoEm 29/04/2020
 */

export default function Header() {
  const classes = useStyles();
  const config = usePartner();
  const LogoHeader = config?.header?.logo;

  return (
    <div className={classes.divContainer}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        className={classes.gridContainer}
      >
        <LogoHeader
          className={classes.logo}
          onClick={() => {
            const url = config.header.logoUrl;
            if (url) window.open(url, '__blank');
          }}
        />
      </Grid>
    </div>
  );
}
